import { doc, updateDoc, deleteField } from "firebase/firestore";
import { db } from "../config/firebaseConfig";
import { listFilesInFolder, deleteFileFromPath } from "../config/firebaseConfig";
import { StorageFile } from "../model/StorageFile";

export const STORAGE_FOLDERS = [
  { label: "Deals", path: "deals/" },
  { label: "Commerces", path: "shops/" },
  { label: "Catégories", path: "Categories/" },
];

const FOLDER_FIRESTORE_MAP: Record<string, { collection: string; field: string }> = {
  "deals/":      { collection: "deals",      field: "image"    },
  "shops/":      { collection: "shops",      field: "logo"     },
  "Categories/": { collection: "Categories", field: "imageUrl" },
};

export async function getStorageFiles(folder: string): Promise<StorageFile[]> {
  return listFilesInFolder(folder);
}

export async function deleteStorageFile(fullPath: string): Promise<void> {
  await deleteFileFromPath(fullPath);

  const folder = fullPath.substring(0, fullPath.indexOf("/") + 1);
  const filename = fullPath.substring(fullPath.indexOf("/") + 1);
  const docId = filename.replace(/\.[^/.]+$/, "");
  const mapping = FOLDER_FIRESTORE_MAP[folder];

  if (mapping && docId) {
    try {
      await updateDoc(doc(db, mapping.collection, docId), {
        [mapping.field]: deleteField(),
      });
    } catch (err) {
      console.warn(`[StorageService] Impossible de vider le champ Firestore pour ${fullPath}:`, err);
    }
  }
}
